import React from "react";
import PropTypes from "prop-types";
import { reduxForm } from "redux-form";
import RadioInput from "./RadioInput";
import WizardFooter from "./WizardFooter";
export const fields = ["supplemental_security_income"];

const validate = (values, props) => {
  const errors = {};
  if (!values.supplemental_security_income) {
    errors.supplemental_security_income = props.allText.shared.required;
  }
  return errors;
};

export const WizardFormSection05 = props => {
  const {
    allText,
    fields: { supplemental_security_income },
    handleSubmit,
    previousPage,
  } = props;
  const text = { ...allText.shared, ...allText.section05 };
  const progress = 4;
  return (
    <form onSubmit={handleSubmit} className="form-horizontal">
      <div className="wizard-page-content">
        <div className="page-title-container">
          <span className="page-title underline">{text.title}</span>
          <span className="wizard-text question-text">{text.subtitle}</span>
        </div>
        <div className="single-question-margin">
          <div className="primary-question">{text.primaryQuestion}</div>
          <RadioInput text={text} field={supplemental_security_income} />
        </div>
      </div>
      <WizardFooter
        text={text}
        previousPage={previousPage}
        progress={progress}
      />
    </form>
  );
};

WizardFormSection05.propTypes = {
  allText: PropTypes.object.isRequired,
  fields: PropTypes.object.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  previousPage: PropTypes.func.isRequired,
};

export default reduxForm({
  form: "wizard",
  fields,
  destroyOnUnmount: false,
  validate,
})(WizardFormSection05);



// WEBPACK FOOTER //
// ./src/components/WizardFormSection05.js